export function timeAgo(updatedAt) {
  const now = new Date();
  const past = new Date(updatedAt);
  const diffMs = now.getTime() - past.getTime();

  const minutes = Math.floor(diffMs / (1000 * 60));
  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes} min ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;

  const days = Math.floor(hours / 24);
  if (days < 7) return `${days} day${days > 1 ? "s" : ""} ago`;

  return past.toLocaleDateString();
}

const STATUS_CONFIG = {
  ToDo: {
    label: "To Be Done",
    className: "bg-[#DAEBFF] text-[#1E61DC]",
  },
  InProgress: {
    label: "In Progress",
    className: "bg-[#E6F0EC] text-[#2DA771]",
  },
  Done: {
    label: "Completed",
    className: "bg-[#C4E9E3] text-[#0B662C]",
  },
  OnHold: {
    label: "On Hold",
    className: "bg-[#FCD7D9] text-[#B52026]",
  },
  Accepted: {
    label: "Accepted",
    className: "bg-[#FFF2CF] text-[#C08F06]",
  },
  awaitingAcceptance: {
    label: "Awaiting Acceptance",
    className: "bg-[#FFF2CF] text-[#C08F06]",
  },
};

export const StatusTag = ({ status }) => {
  const config = STATUS_CONFIG[status];
  if (!config) return null;

  return (
    <span
      className={`inline-flex items-center rounded-lg px-2 justify-center font-bold py-1 text-xs 4444444444444444444444444444444444444444444444 whitespace-nowrap ${config.className}`}
    >
      {config.label}
    </span>
  );
};

// get order management id
export const getOrderManagementId = (data) => {
  if (data?.changeOrderManagement?._id) {
    return data.changeOrderManagement._id;
  }

  if (data?.voidTicketManagement?._id) {
    return data.voidTicketManagement._id;
  }

  if (data?.refundTicketManagement?._id) {
    return data.refundTicketManagement._id;
  }
  if (data?.ticketManagement?._id) {
    return data.ticketManagement._id;
  }

  return null;
};

// get task config based on task type and navigate to order details page
const TASK_CONFIG = {
  ChangeOrder: {
    path: "/order/flight/ticket/changedate/confirmation",
    getId: (task) => task?.changeOrderManagement?._id,
  },
  Void: {
    path: "/order/flight/ticket/void/confirmation",
    getId: (task) => task?.voidTicketManagement?._id,
  },
  Refund: {
    path: "/order/flight/ticket/refund/confirmation",
    getId: (task) => task?.refundTicketManagement?._id,
  },
  Ticketing: {
    path: "/order/flight/ticket/ticketing/confirmation",
    getId: (task) => task?.ticketManagement?._id,
  },
};

const ACTION_MODAL_MAP = {
  OfflineTicketIssue: "remark",
  AddRemarks: "remark",
  CreateQuote: "quote",
  DeclineRequest: "reject",
};

export const openTaskRoute = (action, selectedTask) => {
  if (!selectedTask?.taskType) return;

  const config = TASK_CONFIG[selectedTask.taskType];
  if (!config) return;

  const id = config.getId(selectedTask);
  if (!id) return;

  const modal = ACTION_MODAL_MAP[action];
  const url = modal
    ? `${config.path}/${id}?modal=${modal}`
    : `${config.path}/${id}`;

  window.open(url, "_blank");
};

// get Booking referenceId

const TASK_BOOKING_ID_MAP = {
  ChangeOrder: (data) => data?.changeOrderManagement?.bookingId,
  Void: (data) => data?.voidTicketManagement?.bookingId,
  Refund: (data) => data?.refundTicketManagement?.bookingId,
  Ticketing: (data) => data?.ticketManagement?.bookingId,
};

export const getBookingId = (data) => {
  if (!data?.taskType) return null;

  const resolver = TASK_BOOKING_ID_MAP[data.taskType];
  return resolver ? resolver(data) : null;
};


// return th the task ID
export function getTaskFieldName(taskType) {
  const mapping = {
    Ticketing: "ticketManagementId",
    Void: "voidTicketManagementId",
    Refund: "refundTicketManagementId",
    ChangeOrder: "changeOrderManagementId",
    Support: "supportOrderManagementId",
  };

  return mapping[taskType] || null;
}